import React from 'react';
import PropTypes from 'prop-types';
import FeaturePropType from 'Utils/propTypes/FeaturePropType';
import LocationDetailsCardContainer from 'Components/layouts/kiosk/KioskLayout/LayoutComponents/Locations/LocationDetailsCardContainer';
import * as analytics from 'Utils/analytics';

const SelectedItemPanel = ({selectResultItem, navigate, hideCard, ...props}) => {
    const onClickBack = () => {
        analytics.sendSearchEvent(analytics.ACTIONS.RESULTS, 'Back');
        navigate('search', {saveSearchState: true});
    };

    const onClickClose = () => {
        analytics.sendSearchEvent(analytics.ACTIONS.RESULTS, 'Close');
        hideCard();
    };
    return (
        <LocationDetailsCardContainer
            onClickBack={onClickBack}
            onClickClose={onClickClose}
            {...props}
        />
    );
};

SelectedItemPanel.propTypes = {
    currentKioskFeature: FeaturePropType,
    selectedItem: PropTypes.object,
    tenantFeatures: PropTypes.array,
    searchCardEventListContainer: PropTypes.element,
    travelTimeMins: PropTypes.number,
    hideCard: PropTypes.func,
    navigate: PropTypes.func,
    parkingStatusMapping: PropTypes.object,
    selectResultItem: PropTypes.func,
};

export default SelectedItemPanel;
